<script setup lang="ts">
import type { Component } from 'vue';

const props = withDefaults(
  defineProps<{
    active?: boolean;
    as?: string | Component;
    flex?: boolean;
  }>(),
  {
    as: 'button',
  },
);
</script>

<template>
  <component
    :is="props.as"
    class="ui-outline flex cursor-pointer items-center justify-center rounded"
    :class="{
      'h-20 w-20': !props.flex,
      'ui-touch hover:ui-outline-active': !props.active,
      'ui-touch-active': props.active,
    }"
  >
    <slot />
  </component>
</template>
